export interface CanceledPolicyCritera {
	allowCanceled: boolean;
	allow30Days: boolean;
}

export const BillPay: CanceledPolicyCritera = {
	allowCanceled: false,
	allow30Days: false,
};

export const policyDocs: CanceledPolicyCritera = {
	allowCanceled: true,
	allow30Days: true,
};
